// ─── PAGED READS ────────────────────────────────────────────────────────────
// PostgREST answers at most 1,000 rows per request whatever `.limit(n)` says
// (the server's max-rows), and says nothing about it: `.limit(2000)` returns
// 1,000 and the caller believes it has everything (the admin facts viewer
// showed 1,000 of 5,533; the Route Director's 2,000-message window was 1,000;
// the phone's linked-thread read and the writer-accounts sweep the same —
// 2026-10-19 audit). Read in pages of 1,000 and stop at the first short page.
export const POSTGREST_MAX_ROWS = 1000;

/**
 * @param {(from: number, to: number) => PromiseLike<{data: any[]|null, error: any}>} page
 *   builds the query for one inclusive range; the caller supplies the ORDER.
 * @param {{ max?: number, pageSize?: number }} [opts] hard ceiling on rows read
 * @returns {Promise<{ rows: any[], error: any, truncated: boolean }>}
 *   `truncated` is true when the ceiling was reached with more rows behind it.
 */
export async function fetchPaged(page, { max = 10000, pageSize = POSTGREST_MAX_ROWS } = {}) {
  const rows = [];
  let from = 0;
  while (from < max) {
    const to = Math.min(from + pageSize, max) - 1;
    const { data, error } = await page(from, to);
    if (error) return { rows, error, truncated: false };
    const got = data || [];
    rows.push(...got);
    if (got.length < (to - from + 1)) return { rows, error: null, truncated: false };
    from = to + 1;
  }
  return { rows, error: null, truncated: true };
}
